module.exports = __webpack_public_path__ + "img/curtain-open.0c10aad4.svg";